export default __webpack_public_path__ + "static/media/Data_Access_Role_Configuration.e41aa0a4.png";